import { Output } from "valibot";

import { ConfigurationFieldTypeSchema } from "components/SonicBot/schemas";

export const getInputType = (
  type: Output<typeof ConfigurationFieldTypeSchema>,
): React.InputHTMLAttributes<HTMLInputElement>["type"] => {
  switch (type) {
    case "email": {
      return "email";
    }
    case "number": {
      return "number";
    }
    case "file_url": {
      return "file";
    }
    case "date": {
      return "date";
    }
    default: {
      return "text";
    }
  }
};
